// extracted by mini-css-extract-plugin
export default {"Authentication":"Authentication_Authentication__IB8ch","Shake":"Authentication_Shake__2r2V5","shake":"Authentication_shake__Pd6-i","Error":"Authentication_Error__NDcyy"};